// Fixed-at helpers for Mark Fixed (DPS-4722). The server stores naive UTC; the
// datetime-local input shows the viewer's local time.

const toLocalInput = (date) =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

/** "Now" as a datetime-local value (YYYY-MM-DDTHH:mm, local time). */
export const localNow = () => toLocalInput(new Date());

/** datetime-local value → naive UTC ISO (YYYY-MM-DDTHH:mm:ss) for the API. */
export const toUtcNaive = (local) => new Date(local).toISOString().slice(0, 19);

/**
 * Naive-UTC ISO from the API (or one with an explicit offset) → datetime-local
 * value in the viewer's zone; null when missing or unparseable.
 */
export function localInputFromUtc(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(iso);
  const date = new Date(hasZone ? iso : `${iso}Z`);
  return Number.isNaN(date.getTime()) ? null : toLocalInput(date);
}
